import {
  BehaviorSubject,
  catchError,
  delay,
  filter,
  from,
  mergeMap,
  Observable,
  of,
} from 'rxjs';
import { Dependencies } from '../../../../configurations/dependencies/dependencies.interface';
import { Action, AnyAction } from '../../../state/action.type';
import { AppState } from '../../../state/app.state';
import {
  retrieveFighters,
  retrieveFightersFailure,
  retrieveFightersSuccess,
} from '../../../state/fighter/fighter.action';
import {
  RetrieveFighters,
  RETRIEVE_FIGHTERS,
} from '../../../state/fighter/fighter.action.type';
import { FIGHTER_USECASE_ERROR_MESSAGES } from '../../errors/usecases.errorMessages/fighterUsecase.error.messages';
import { Fighter } from '../../models/fighter.model';

const DEFAULT_RETRY_DELAY = 300;

export const retrieveFightersUsecase = (
  action$: Observable<Action>,
  _state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
): Observable<Action> =>
  action$.pipe(
    filter(
      (action: AnyAction): action is RetrieveFighters =>
        action.type === RETRIEVE_FIGHTERS,
    ),
    mergeMap((action: RetrieveFighters) =>
      from(dependencies.fighterGateway.getFighters()).pipe(
        mergeMap((fighters: Fighter[]) => {
          return [retrieveFightersSuccess(fighters)];
        }),
        catchError((error: Error) => {
          console.warn('retrieveFightersUsecase failed:', error.message);
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const remainingRetries = action.payload.retry
            ? action.payload.retry - 1
            : 0;
          if (remainingRetries) {
            return of(retrieveFighters({ retry: remainingRetries })).pipe(
              delay(DEFAULT_RETRY_DELAY),
            );
          }
          return of(
            retrieveFightersFailure(
              FIGHTER_USECASE_ERROR_MESSAGES.RETRIEVAL_FAILED,
            ),
          );
        }),
      ),
    ),
  );
